// extracted by mini-css-extract-plugin
module.exports = {"button":"OrderDetailReadySmsButton_button__1telS"};